// extracted by mini-css-extract-plugin
export default {"container":"index_container__OnJMD","link":"index_link__VMSpU"};